import { render, staticRenderFns } from "./ShoppingCartPositiontextAdd.vue?vue&type=template&id=98a433a6"
import script from "./ShoppingCartPositiontextAdd.vue?vue&type=script&lang=js"
export * from "./ShoppingCartPositiontextAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports